export default "__VITE_ASSET__Dcvh68MM__"